import { takeLatest, call, put } from 'redux-saga/effects'
import {
    subscriptionList, addSubscriptionAPI, updateSubscriptionAPI, updateSubscriptionStatusAPI,
    updateTransactionStatusAPI, newTransactionAPI
} from '../api-requests/subscription';
import {
    subscriptionListRequestError, subscriptionListRequestSuccess,
    addSubscriptionRequestError, addSubscriptionRequestSuccess, updateSubscriptionRequestError,
    updateSubscriptionRequestSuccess, updateSubscriptionStatusRequestError, updateSubscriptionStatusRequestSuccess,
    updateTransactionStatusRequestError, updateTransactionStatusRequestSuccess,
    newTransactionRequestError, newTransactionRequestSuccess
} from './subscription.action';
import { SubscriptionActionTypes } from './subscription.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';
import { APP_CONSTANTS } from '../../utils/AppConstants';

function* handleNewTransactionRequest({ payload }) {
    try {
        const response = yield call(newTransactionAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(newTransactionRequestSuccess(decryptedData))
            } else {
                yield put(newTransactionRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SubscriptionActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(newTransactionRequestError(error.response.data))
        }
    }
}

export function* newTransactionReq() {
    yield takeLatest(SubscriptionActionTypes.NEW_TRANSACTION_REQUEST, handleNewTransactionRequest)
}

function* handleUpdateTransactionStatusRequest({ payload }) {
    try {
        const response = yield call(updateTransactionStatusAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateTransactionStatusRequestSuccess(decryptedData))
            } else {
                yield put(updateTransactionStatusRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SubscriptionActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateTransactionStatusRequestError(error.response.data))
        }
    }
}

export function* updateTransactionStatusReq() {
    yield takeLatest(SubscriptionActionTypes.UPDATE_TRANSACTION_STATUS_REQUEST, handleUpdateTransactionStatusRequest)
}

function* handleUpdateSubscriptionStatusRequest({ payload }) {
    try {
        const response = yield call(updateSubscriptionStatusAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateSubscriptionStatusRequestSuccess(decryptedData))
            } else {
                yield put(updateSubscriptionStatusRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SubscriptionActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateSubscriptionStatusRequestError(error.response.data))
        }
    }
}

export function* updateSubscriptionStatusReq() {
    yield takeLatest(SubscriptionActionTypes.UPDATE_SUBSCRIPTION_STATUS_REQUEST, handleUpdateSubscriptionStatusRequest)
}

function* handleUpdateSubscriptionRequest({ payload }) {
    try {
        const response = yield call(updateSubscriptionAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateSubscriptionRequestSuccess(decryptedData))
            } else {
                yield put(updateSubscriptionRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SubscriptionActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateSubscriptionRequestError(error.response.data))
        }
    }
}

export function* updateSubscriptionReq() {
    yield takeLatest(SubscriptionActionTypes.UPDATE_SUBSCRIPTION_REQUEST, handleUpdateSubscriptionRequest)
}

function* handleAddSubscriptionRequest({ payload }) {
    try {
        const response = yield call(addSubscriptionAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addSubscriptionRequestSuccess(decryptedData))
            } else {
                yield put(addSubscriptionRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: SubscriptionActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(addSubscriptionRequestError(error.response.data))
        }
    }
}

export function* addSubscriptionReq() {
    yield takeLatest(SubscriptionActionTypes.ADD_SUBSCRIPTION_REQUEST, handleAddSubscriptionRequest)
}

function* handleSubscriptionList({ payload }) {
    try {
        const response = yield call(subscriptionList, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(subscriptionListRequestSuccess(decryptedData))
            } else {
                yield put(subscriptionListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        displayConsoleLog(error.response.data)
        yield put(subscriptionListRequestError(error.response.data))
    }
}

export function* subscriptionListReq() {
    yield takeLatest(SubscriptionActionTypes.SUBSCRIPTION_LIST_REQUEST, handleSubscriptionList)
}

